<template lang="pug">
v-fade-transition(mode='out-in')
  #news
    section-article(:article='article', :authors='article.authors')
</template>

<script setup>
import { createError, useAsyncData, useRoute } from 'nuxt/app'
import {
  createAbsoluteUrl,
  createPageSchemaContext,
  createSeoMeta,
} from '~/utils/schema'
import { publicAssetPath } from '~/utils/assets'
import { stripLocalePrefix } from '~/utils/i18n'

defineOptions({
  name: 'ArticlePage',
})

const route = useRoute()
const path = route.params.slug.join('/')
const contentPath = stripLocalePrefix(route.path)

const { data: article } = await useAsyncData(`article-${path}`, () =>
  queryCollection('articles').path(contentPath).first(),
)

if (!article.value) {
  throw createError({ statusCode: 404, message: 'Article not found' })
}

const { baseUrl, pageUrl } = createPageSchemaContext(
  route.path,
  useRuntimeConfig().public.baseUrl,
)
const imageUrl = createAbsoluteUrl(
  publicAssetPath(article.value.image),
  baseUrl,
)

useSeoMeta(
  createSeoMeta(
    article.value.title,
    article.value.description,
    pageUrl,
    imageUrl,
  ),
)
</script>
